export default __webpack_public_path__ + "static/media/Ring of Old Acheron.6af35c83.jpg";